export default __webpack_public_path__ + "static/media/open-box.43ce8855.png";